(function(){
if(window.HgsFinderSection){window.HgsFinderSection(document);return;}
function init(root){
  if(!root || root.dataset.hgfInit) return;
  root.dataset.hgfInit = '1';

  var cfg = JSON.parse(root.querySelector('[data-finder-config]').textContent);
  var SHOP = '/products/';
  var DATA_URL = cfg.dataUrl;
  var PRIVACY = cfg.privacy;
  var REQUIRE_EMAIL = cfg.requireEmail;
  var WA = cfg.whatsapp;
  var HOURS = cfg.hours;
  var PHONE = (cfg.phone || '0333 050 4282');

  var NEED = {
    "Sheds & Storage":"Somewhere for the clutter",
    "Greenhouses":"Somewhere to grow, all year",
    "Summerhouses":"Somewhere to sit out",
    "Log Cabins":"A proper room, year round",
    "Garden Rooms & Offices":"A room to work in",
    "Garden Structures":"Shade, shelter and somewhere to play",
    "Garden Furniture":"Somewhere to sit and enjoy the garden",
    "Cooking & Heating":"Eating outdoors for longer",
    "Spa":"Warm water, whatever the weather",
    "Pets & Wildlife":"Shelter for the animals"
  };
  var NAV = Object.keys(NEED);
  var PRICE = [["Under £500",0,500],["£500–999",500,1000],["£1,000–1,999",1000,2000],["£2,000–3,499",2000,3500],["£3,500 and up",3500,1e9]];
  var WHEN  = [["As soon as possible","within about two weeks",2],["In the next month or so","two to four weeks",4],["I can wait a bit","up to a couple of months",8],["No rush at all","happy to wait for the right one",999]];
  var SHED_SIZE = [["Up to 6ft","a corner or a narrow side return",0,6],["6 to 8ft","the usual garden shed",6,8],["8 to 10ft","room for a bench as well",8,10],["10 to 12ft","a workshop, not just storage",10,12],["Over 12ft","the big end of the range",12,999]];
  var BROAD = [["Small","up to about 8ft",0,8],["Medium","somewhere around 8 to 12ft",8,12],["Large","over 12ft",12,999]];
  var USE_SIZE = {"Sheds & Storage":SHED_SIZE,"Log Cabins":BROAD,"Greenhouses":BROAD,"Garden Rooms & Offices":BROAD,"Summerhouses":BROAD};
  var SKIP_WHEN = {"Cooking & Heating":1,"Log Cabins":1,"Pets & Wildlife":1,"Spa":1};
  var USE_STYLE = {"Sheds & Storage":1,"Cooking & Heating":1};
  var ANY = "I don't mind";
  var SUBMAP = {"Garden Office":"Garden Room"};
  var HIDE_SUB = {"Garden Room Accessory":1,"Surround Furniture":1,"Cover":1,"Padlock":1,"Bird Feeder":1};

  var DATA=[], A={}, LEAD=null, SHOWN=8, MED={};
  var stage = root.querySelector('[data-stage]');
  var crumbs = root.querySelector('[data-crumbs]');
  var form = root.querySelector('form[action*="/contact"]');

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function money(n){ return '£' + Number(n).toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function toTop(){ try{ root.scrollIntoView({behavior:'smooth',block:'start'}); }catch(e){} }
  /* Images are fetched live per card rather than baked into the JSON, so they
     can never go stale and the data file stays small. */
  var IMGC = {};
  function img(p,w){ return '<span class="hgf-shot" data-img="'+esc(p.h)+'" data-w="'+w+'"></span>'; }
  function fillImages(scope){
    Array.prototype.forEach.call(scope.querySelectorAll('[data-img]'), function(el){
      var h=el.dataset.img, w=el.dataset.w;
      /* featured_image comes back with no query string, so the width parameter
         needs a ? not an & — appending & gives a 404 from the Shopify CDN. */
      function paint(src){ if(src) el.innerHTML='<img src="'+src+(src.indexOf('?')>-1?'&':'?')+'width='+w+'" alt="" loading="lazy">'; }
      if(IMGC[h]!==undefined) return paint(IMGC[h]);
      fetch(SHOP+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null;}).then(function(d){
        var src = d && d.featured_image ? String(d.featured_image).split('?')[0] : '';
        if(src.indexOf('//')===0) src='https:'+src;
        IMGC[h]=src; paint(src);
      }).catch(function(){ IMGC[h]=''; });
    });
  }

  fetch(DATA_URL).then(function(r){return r.json();}).then(function(d){
    DATA = d.filter(function(p){ return p.c && !HIDE_SUB[p.s]; })
            .map(function(p){ if(SUBMAP[p.s]){ p = Object.assign({},p); p.s = SUBMAP[p.s]; } return p; });
    medians(); render();
  }).catch(function(){ stage.innerHTML = '<p class="hgf-loading">Sorry — we could not load the range just now. Please <a href="/pages/contact">get in touch</a> and we will help directly.</p>'; });

  function medians(){
    var by={}; DATA.forEach(function(p){ (by[p.c]=by[p.c]||[]).push(p.p); });
    Object.keys(by).forEach(function(c){ by[c].sort(function(a,b){return a-b;}); MED[c]=by[c][Math.floor(by[c].length/2)]; });
  }
  function addOn(p){ return MED[p.c] > 0 && p.p < MED[p.c]*0.2; }
  function core(arr){ var c=arr.filter(function(p){return !addOn(p);}); return c.length>=3?c:arr; }

  function pool(a, skip){
    return DATA.filter(function(p){
      if(a.cat && !skip.cat && p.c!==a.cat) return false;
      if(a.kind && a.kind!==ANY && !skip.kind && p.s!==a.kind) return false;
      if(a.style && a.style!==ANY && !skip.style && p.y!==a.style) return false;
      if(a.size && a.size!==ANY && !skip.size){
        var b=(USE_SIZE[a.cat]||[]).filter(function(x){return x[0]===a.size;})[0];
        if(!b || p.ft==null || p.ft<=b[2] || p.ft>b[3]) return false;
      }
      if(a.budget && a.budget!==ANY && !skip.budget){
        var q=PRICE.filter(function(x){return x[0]===a.budget;})[0];
        if(!q || p.p<q[1] || p.p>=q[2]) return false;
      }
      if(a.when && a.when!==ANY && !skip.when){
        var w=WHEN.filter(function(x){return x[0]===a.when;})[0];
        if(!w || p.w==null || p.w>w[2]) return false;
      }
      return true;
    });
  }
  function kinds(cat){
    var m={}; DATA.forEach(function(p){ if(p.c===cat) m[p.s]=(m[p.s]||0)+1; });
    return Object.keys(m).filter(function(k){return k && k!=='null';}).map(function(k){return [k,m[k]];}).sort(function(a,b){return b[1]-a[1];});
  }
  /* Style options that just repeat the type already chosen are dropped —
     otherwise a shed buyer gets asked "Type: Wooden Shed" then "Style: Wooden Shed". */
  function styles(a){
    var m={}; pool(a,{style:1}).forEach(function(p){ m[p.y]=(m[p.y]||0)+1; });
    return Object.keys(m).filter(function(k){ return k && m[k]>=2 && k!==a.kind; })
                 .map(function(k){return [k,m[k]];}).sort(function(a,b){return b[1]-a[1];}).slice(0,8);
  }
  function nextQ(){
    if(!A.cat) return 'cat';
    if(!A.kind) return 'kind';
    if(USE_SIZE[A.cat] && !A.size) return 'size';
    if(!A.budget) return 'budget';
    if(!SKIP_WHEN[A.cat] && !A.when) return 'when';
    if(USE_STYLE[A.cat] && !A.style && pool(A,{style:1}).length>25 && styles(A).length>=2) return 'style';
    if(REQUIRE_EMAIL && !LEAD) return 'lead';
    return null;
  }
  var QT = {
    cat:["What are you looking for?","Pick the closest — nothing is set in stone."],
    kind:["Which of these sounds right?","Only what we actually stock is listed."],
    size:["How much room have you got?","Roughly is fine."],
    budget:["What are you looking to spend?","Including VAT. We'll flag anything just over."],
    when:["How soon do you need it?","Most are built after you order, so this one matters."],
    style:["Any preference on the style?","Last one — we only ask when there's a lot to choose from."]
  };

  function render(){
    var q = nextQ(); drawCrumbs();
    if(!q) return results();
    if(q==='lead') return lead();
    var title=QT[q][0], hint=QT[q][1];
    var n = ['cat','kind','size','budget','when','style'].indexOf(q)+1, opts=[];
    if(q==='cat'){
      var m={}; DATA.forEach(function(p){ m[p.c]=1; });
      opts = NAV.filter(function(c){return m[c];}).map(function(c){ return [c, NEED[c], c]; });
    } else if(q==='kind'){ opts = kinds(A.cat).map(function(k){ return [k[0],'',k[0]]; }); }
    else if(q==='size'){ opts = (USE_SIZE[A.cat]||[]).filter(function(b){ var t=Object.assign({},A); t.size=b[0]; return pool(t,{}).length; }).map(function(b){ return [b[0],b[1],b[0]]; }); }
    else if(q==='budget'){ opts = PRICE.filter(function(b){ var t=Object.assign({},A); t.budget=b[0]; return pool(t,{}).length; }).map(function(b){ return [b[0],'',b[0]]; }); }
    else if(q==='when'){ opts = WHEN.filter(function(b){ var t=Object.assign({},A); t.when=b[0]; return pool(t,{}).length; }).map(function(b){ return [b[0],b[1],b[0]]; }); }
    else { opts = styles(A).map(function(k){ return [k[0],'',k[0]]; }); }

    stage.innerHTML = '<div class="hgf-panel"><p class="hgf-step">Question '+n+'</p><h3>'+title+'</h3><p class="hgf-hint">'+hint+'</p><div class="hgf-opts">'
      + opts.map(function(o){ return '<button type="button" class="hgf-opt" data-q="'+q+'" data-v="'+esc(o[2])+'"><strong>'+esc(o[0])+'</strong>'+(o[1]?'<small>'+esc(o[1])+'</small>':'')+'</button>'; }).join('')
      + (q!=='cat' ? '<button type="button" class="hgf-opt any" data-q="'+q+'" data-v="'+esc(ANY)+'"><strong>'+esc(ANY)+'</strong><small>skip this one</small></button>' : '')
      + '</div></div>';
    Array.prototype.forEach.call(stage.querySelectorAll('.hgf-opt'), function(b){
      b.addEventListener('click', function(){ A[b.dataset.q]=b.dataset.v; SHOWN=8; render(); toTop(); });
    });
  }

  function drawCrumbs(){
    var order=[['cat','Looking for'],['kind','Type'],['size','Size'],['budget','Budget'],['when','When'],['style','Style']];
    crumbs.innerHTML = order.filter(function(o){return A[o[0]];}).map(function(o){
      return '<span class="hgf-crumb">'+o[1]+': <b>'+esc(A[o[0]])+'</b><button type="button" data-k="'+o[0]+'" aria-label="Change '+o[1]+'">✕</button></span>';
    }).join('');
    Array.prototype.forEach.call(crumbs.querySelectorAll('button'), function(b){
      b.addEventListener('click', function(){
        var i=0; for(var k=0;k<order.length;k++){ if(order[k][0]===b.dataset.k){ i=k; break; } }
        for(var j=i;j<order.length;j++) delete A[order[j][0]];
        LEAD=null; SHOWN=8; render();
      });
    });
  }

  function lead(){
    stage.innerHTML = '<div class="hgf-panel"><p class="hgf-step">Nearly there</p><h3>Where shall we send your shortlist?</h3>'
      + '<p class="hgf-hint">Your three appear on the next screen. Leave your email to request a copy from our team. We can confirm delivery costs once we have your postcode.</p>'
      + '<div class="hgf-form">'
      + '<div><label for="hgf-em">Email address</label><input id="hgf-em" type="email" autocomplete="email" placeholder="you@example.com" required></div>'
      + '<div><label for="hgf-ph">Phone number <i>(optional)</i></label><input id="hgf-ph" type="tel" autocomplete="tel" placeholder="07…"></div>'
      + '<p class="hgf-err" data-err></p>'
      + '<button type="button" class="hgf-btn" data-go style="justify-self:start">Show me my three &rarr;</button>'
      + '<button type="button" class="hgf-skip" data-skip>No thanks, just show me</button>'
      + '<p class="hgf-fine">We will only use this to send your shortlist and answer your question. No lists, no sharing, unsubscribe any time. See our <a href="'+esc(PRIVACY)+'">privacy policy</a>.</p>'
      + '</div></div>';
    stage.querySelector('[data-skip]').addEventListener('click', function(){ LEAD={skipped:true}; render(); toTop(); });
    stage.querySelector('[data-go]').addEventListener('click', function(){
      var em=stage.querySelector('#hgf-em').value.trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(em)){ stage.querySelector('[data-err]').textContent='That email does not look right — check it and try again.'; return; }
      LEAD={email:em, phone:stage.querySelector('#hgf-ph').value.trim()};
      render(); toTop();
    });
  }

  function sendLead(picks){
    if(!form || !LEAD || !LEAD.email) return;
    try{
      var body = 'Help me choose — shortlist request\n\n'
        + Object.keys(A).map(function(k){ return k+': '+A[k]; }).join('\n')
        + '\n\nShortlist:\n' + picks.map(function(x){ return x[0]+': '+x[1].t+' — '+money(x[1].p)+' — '+location.origin+SHOP+x[1].h; }).join('\n')
        + (LEAD.phone ? '\n\nPhone: '+LEAD.phone : '');
      form.querySelector('[data-lead-email]').value = LEAD.email;
      form.querySelector('[data-lead-phone]').value = LEAD.phone || '';
      form.querySelector('[data-lead-body]').value = body;
      var requestLead=LEAD;
      function status(message){ requestLead.statusMessage=message;if(LEAD!==requestLead)return;var el=root.querySelector('[data-lead-status]');if(el)el.textContent=message; }
      fetch(form.action, {method:'POST', body:new FormData(form)}).then(function(response){
        if(!response.ok)throw new Error('Request failed');
        return response.text();
      }).then(function(body){
        if(body.indexOf('data-hgs-finder-contact-success')<0)throw new Error('Submission not confirmed');
        status('Your request has reached the store. Our team will follow up by email.');
      }).catch(function(){status('We could not confirm your email request. Your results are still below; please contact us to request a copy.');});
      LEAD.sent = true;
    }catch(e){}
  }

  /* Opens WhatsApp with their answers and shortlist already typed, so whoever
     picks it up knows what they are looking at before they say hello. */
  function waBlock(picks){
    if(!WA) return '<div class="hgf-aside"><strong>Still weighing them up?</strong> Drop us a message and we will help you pick the right one.</div>';
    var lines = Object.keys(A).map(function(k){ return A[k]; }).filter(function(v){ return v && v!==ANY; }).join(', ');
    var list = (picks||[]).map(function(x){ return x[1].t; }).join(' / ');
    var txt = 'Hi, I used Help me choose on your site. I am after: ' + lines + '.' + (list ? ' It showed me: ' + list + '.' : '') + ' Could you help me pick?';
    return '<div class="hgf-aside"><strong>Still weighing them up?</strong> Message us on WhatsApp and we will help you pick the right one — it takes two minutes.'
      + '<div class="hgf-row" style="margin-top:12px"><a class="hgf-btn" target="_blank" rel="noopener" href="https://wa.me/'+encodeURIComponent(WA)+'?text='+encodeURIComponent(txt)+'">Chat on WhatsApp</a></div>'
      + '<p style="margin:10px 0 0;font-size:12.5px;color:var(--hgf-grey)">'+esc(HOURS)+'. Outside those hours leave a message and we will come back to you.</p></div>';
  }
  function phoneBlock(){ if(!PHONE) return ''; var tel=String(PHONE).split(' ').join(''); return '<div class="hgf-aside"><strong>Rather talk it through?</strong> Call us on <a href="tel:'+esc(tel)+'">'+esc(PHONE)+'</a> and we will go through your shortlist with you.<p style="margin:10px 0 0;font-size:12.5px;color:var(--hgf-grey)">'+esc(HOURS)+'.</p></div>'; }

  function stem(p){ return (p.b||'')+'|'+String(p.t||'').toLowerCase().replace(/[^a-z0-9 ]/g,'').split(/\s+/).slice(0,4).join(' '); }
  function matches(){
    var relaxed=[], skip={}, p=core(pool(A,{}));
    var ladder=[['budget','budget'],['when','timing'],['size','size'],['style','style']], i=0;
    while(p.length<3 && i<ladder.length){
      var key=ladder[i][0], label=ladder[i][1]; i++;
      if(A[key] && A[key]!==ANY){ relaxed.push(label); skip[key]=1; p=core(pool(A,skip)); }
    }
    p.sort(function(a,b){ return a.p-b.p; });
    p.sort(function(a,b){ return (a.oos?1:0)-(b.oos?1:0); });
    return {all:p, relaxed:relaxed};
  }
  /* Lead times can carry per-option detail ("4–5 weeks (silver frame) · 8–10 weeks
     (powder-coated)"). The card shows the headline; the product page has it all. */
  function shortLT(s){
    if(!s) return 'Lead time on request';
    var t = String(s).split('·')[0].split('(')[0].trim().replace(/[,;]$/,'');
    return (t.length < String(s).trim().length) ? t + ' — options vary' : t;
  }
  function round0(n){ return Math.round(n).toLocaleString('en-GB'); }

  /* Benefit-led only. The price is on the card already — repeating the gap
     anchors the customer on cost, which is the last thing we want on the
     option we are recommending. */
  function whyLine(p, base, isTop){
    if(!base || p===base) return 'Covers everything you asked for.';
    var bits=[];
    if(p.ft!=null && base.ft!=null && p.ft>base.ft) bits.push(p.ft+'ft rather than '+base.ft+'ft — more room to work with');
    if(p.w!=null && base.w!=null && p.w < base.w) bits.push('ready sooner');
    if(!bits.length) return '';
    var t = bits.length>1 ? bits[0]+', and '+bits[1] : bits[0];
    return t.charAt(0).toUpperCase()+t.slice(1)+'.';
  }
  function three(all){
    if(!all.length) return [];
    var value=all[0], best=all[all.length-1], mid=null;
    if(all.length>2){
      var band=all.slice(1,-1);
      var lo=Math.floor(band.length/3);
      var win=band.slice(lo, Math.max(Math.ceil(band.length*2/3), lo+1));
      /* Prefer a different SIZE from the other two — three cards all reading 8ft
         tell the customer nothing. Brand variety is not a goal: if Shire is most
         of the range, three Shire products is an honest picture. */
      var bySize = win.filter(function(p){ return p.ft!=null && p.ft!==value.ft && p.ft!==best.ft; });
      var byLine = win.filter(function(p){ return stem(p)!==stem(value) && stem(p)!==stem(best); });
      var from = bySize.length ? bySize : (byLine.length ? byLine : win);
      mid = from.slice().sort(function(a,b){ return (b.m||0)-(a.m||0); })[0];
    }
    var out=[["Best value",value,whyLine(value,null,false)],
             ["Best all-rounder",mid,mid?whyLine(mid,value,false):''],
             ["Top of the range",best,whyLine(best,value,true)]];
    var seen=[];
    return out.filter(function(x){ if(!x[1]||seen.indexOf(x[1])>-1) return false; seen.push(x[1]); return true; });
  }

  /* Which card we put our weight behind: the one that earns the most per sale,
     not simply the dearest. Across 225 shortlists those are the same product 76%
     of the time; in the other 24% this is worth about £50 a sale. Falls back to
     the dearest where we have no cost. */
  function recIndex(picks){
    var gp = picks.map(function(x){ return (x[1].m!=null) ? x[1].p/1.2*x[1].m/100 : null; });
    if(gp.some(function(g){ return g==null; })) return picks.length-1;
    var bi=0; for(var i=1;i<gp.length;i++) if(gp[i]>gp[bi]) bi=i;
    return bi;
  }

  /* The lede only promises a price ladder when there actually is one. */
  function ledeFor(picks){
    if(picks.length<2) return 'The closest match to what you have told us.';
    var ps=picks.map(function(x){return x[1].p;}), lo=Math.min.apply(null,ps), hi=Math.max.apply(null,ps);
    if(hi < lo*1.35) return 'All three are close in price — here is what separates them.';
    return 'Different ends of the same shortlist, so you can see what more money actually buys you.';
  }

  function results(){
    var r=matches(), picks=three(r.all), REC=recIndex(picks);
    var inS=r.all.filter(function(p){ return !p.oos; }); if(inS.length>=3){ picks=three(inS); REC=recIndex(picks); }
    if(!picks.length){
      stage.innerHTML='<div class="hgf-panel"><h3>Nothing quite fits that</h3><p class="hgf-hint">Tell us what you are after and we will say honestly whether we have something — or whether you would do better elsewhere.</p>'+waBlock([])+'<div class="hgf-row"><button type="button" class="hgf-btn" data-again>Start again</button></div></div>';
      stage.querySelector('[data-again]').addEventListener('click', function(){ A={}; LEAD=null; render(); toTop(); });
      return;
    }
    if(LEAD && LEAD.email && !LEAD.sent) sendLead(picks);
    var extras=r.all.filter(function(p){ return !picks.some(function(x){ return x[1]===p; }); });

    stage.innerHTML = '<div class="hgf-panel"><p class="hgf-step">Your shortlist</p><h3>These three fit what you have told us</h3>'
      + '<p class="hgf-hint">'+ledeFor(picks)+'</p>'
      + (r.relaxed.length ? '<p class="hgf-flag">To find three that fit we have stretched your '+r.relaxed.join(' and ')+' a little.</p>' : '')
      + '<div class="hgf-picks">' + picks.map(function(x,i){
          var tag=x[0], p=x[1], why=x[2];
          return '<article class="hgf-pick'+(i===REC?' hgf-pick--rec':'')+'"><div class="hgf-tag">'+tag+(i===REC?' · OUR PICK':'')+'</div>'
            + '<a href="'+SHOP+encodeURIComponent(p.h)+'">'+img(p,480)+'</a>'
            + '<div class="hgf-body"><span class="hgf-brand">'+esc(p.b)+'</span><h4>'+esc(p.t)+'</h4>'
            + '<div class="hgf-cost">'+money(p.p)+(p.oos?'<span class="hgf-oos">Out of stock</span>':'')+'</div>'
            + '<p class="hgf-spec">'+esc(p.s)+(p.ft?' · '+p.ft+'ft':'')+'<br>'+esc(shortLT(p.lt))+'</p>'
            + '<p class="hgf-why">'+why+'</p>'
            + '<a class="hgf-btn hgf-btn--sm" href="'+SHOP+encodeURIComponent(p.h)+'">View this one</a></div></article>';
        }).join('') + '</div>'
      + (extras.length ? '<div class="hgf-more"><div class="hgf-top"><h2 style="font-size:17px">More that fit what you have told us</h2></div><div class="hgf-grid">'
          + extras.slice(0,SHOWN).map(function(p){
              return '<a class="hgf-prod" href="'+SHOP+encodeURIComponent(p.h)+'">'+img(p,320)
                + '<span class="hgf-pb"><span class="hgf-pt">'+esc(p.t)+'</span><span class="hgf-pp">'+money(p.p)+(p.oos?'<span class="hgf-oos">Out of stock</span>':'')+'</span>'
                + '<span class="hgf-pl">'+esc(shortLT(p.lt))+'</span></span></a>';
            }).join('') + '</div>'
          + (extras.length>SHOWN ? '<div class="hgf-row"><button type="button" class="hgf-btn hgf-btn--ghost" data-more>Show more that fit</button></div>' : '')
          + '</div>' : '')
      + (LEAD && LEAD.email
          ? '<div class="hgf-aside" role="status" data-lead-status>Sending your request. Your shortlist is ready below.</div>'
          : '')
      + ((!LEAD || !LEAD.email) ? '<details class="hgf-aside"><summary style="cursor:pointer;font-weight:700">Email me these results</summary>'
          + '<p>Request a copy of this shortlist from our team. Your results will stay on this page.</p>'
          + '<form class="hgf-form" data-results-email><div><label>Email address<input type="email" name="email" autocomplete="email" placeholder="you@example.com" required></label></div>'
          + '<div><label>Phone number <i>(optional)</i><input type="tel" name="phone" autocomplete="tel"></label></div>'
          + '<button type="submit" class="hgf-btn">Request my shortlist by email</button>'
          + '<p class="hgf-fine">We will use these details to respond to your request. <a href="'+esc(PRIVACY)+'">Privacy policy</a>.</p></form></details>' : '')+ phoneBlock()
      + waBlock(picks)
      + '<div class="hgf-row"><button type="button" class="hgf-btn" data-again>Start again</button><button type="button" class="hgf-btn hgf-btn--ghost" data-back>Change my last answer</button></div></div>';

    if(LEAD && LEAD.statusMessage){var statusEl=stage.querySelector('[data-lead-status]');if(statusEl)statusEl.textContent=LEAD.statusMessage;}
    var emailResults=stage.querySelector('[data-results-email]');
    if(emailResults)emailResults.addEventListener('submit',function(e){
      e.preventDefault();
      if(!emailResults.reportValidity())return;
      LEAD={email:emailResults.elements.email.value.trim(),phone:emailResults.elements.phone.value.trim()};
      results();
    });
    fillImages(stage);
    var mb=stage.querySelector('[data-more]'); if(mb) mb.addEventListener('click', function(){ SHOWN+=12; results(); });
    stage.querySelector('[data-again]').addEventListener('click', function(){ A={}; LEAD=null; SHOWN=8; render(); toTop(); });
    stage.querySelector('[data-back]').addEventListener('click', function(){
      LEAD=null; SHOWN=8;
      var order=['style','when','budget','size','kind','cat'];
      for(var i=0;i<order.length;i++){ if(A[order[i]]){ delete A[order[i]]; break; } }
      render();
    });
  }
}
function mount(scope){if(scope.matches&&scope.matches('[data-hgs-finder]'))init(scope);scope.querySelectorAll('[data-hgs-finder]').forEach(init);}
window.HgsFinderSection=mount;
mount(document);
document.addEventListener('shopify:section:load',function(e){mount(e.target)});
})();
